"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const value = schema_1.Schema.number()
    .integer()
    .min(0)
    .max(99)
    .interpretation({ vocab: "htx", code: "hospitalizations" })
    .tag({ vocab: "snomed", code: "416683003" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
